export default __webpack_public_path__ + "72464abcae3d7fd14fbfecc10db0ced9.png";